import { removeStagingObject } from "./Api";

// Autosaved new-invoice draft (localStorage), so a session timeout, crash or
// accidental navigation never loses in-progress work. Mirrors the SOA draft flow.
const INVOICE_DRAFT_KEY = "invoice-form-draft-v1";

export const readInvoiceDraft = () => {
  try {
    const raw = window.localStorage.getItem(INVOICE_DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const writeInvoiceDraft = (draft) => {
  try {
    window.localStorage.setItem(INVOICE_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    /* storage full or unavailable — autosave is best-effort */
  }
};

export const clearInvoiceDraft = () => {
  try {
    window.localStorage.removeItem(INVOICE_DRAFT_KEY);
  } catch {
    /* ignore */
  }
};

// Discard = clear the draft AND delete the staged S3 uploads it references.
export const discardInvoiceDraft = () => {
  const draft = readInvoiceDraft();
  if (draft) {
    const keys = [
      ...(draft.pendingFiles || []).map((f) => f?.key),
      ...((draft.form?.groups || []).flatMap((g) =>
        (g.rows || []).flatMap((r) => (r.files || []).map((f) => f?.key))
      )),
    ].filter(Boolean);
    keys.forEach((k) => removeStagingObject(k).catch(() => {}));
  }
  clearInvoiceDraft();
};
